import {action, makeObservable, observable, reaction} from 'mobx'
import Club from '../models/Club'
import {post} from '../common/requester'
import Member from "../models/Member";
import MemberQuery from "../models/MemberQuery";
import Person from '../models/Person'
import Company from "../models/Company";
import Team from '../models/Team'
import TeamQuery from '../models/TeamQuery'

class ClubStore {
  loading = false;
  club = new Club();
  member = new Member();
  memberQuery = new MemberQuery();
  members = [];
  branch = new Company();
  branches = [];
  team = new Team();
  teamQuery = new TeamQuery();
  teams = [];
  freeMembers = [];
  
  constructor() {
    makeObservable(this, {
      loading: observable,
      club: observable,
      member: observable,
      members: observable,
      memberQuery: observable,
      branch: observable,
      branches: observable,
      team: observable,
      teams: observable,
      teamQuery: observable,
      freeMembers: observable,
      getClub: action,
      saveMember: action,
      getMembers: action,
      setMembers: action,
      resetMember: action,
      getMember: action,
      resetBranch: action,
      saveBranch: action,
      getBranches: action,
      setBranches: action,
      getBranch: action,
      saveTeam: action,
      resetTeam: action,
      getTeams: action,
      setTeams: action,
      getTeam: action,
      getFreeMembers: action,
      setFreeMembers: action,
      addTeamMembers: action,
      deleteTeamMember: action,
      setLoading: action,
    })

    reaction(()=>this.club.id, (new_id, old_id) => {
      this.memberQuery.setProperty('company_id', new_id)
      this.branch.setProperty('parent_id', new_id)
    })
  }

  setLoading(loading) {
    this.loading = loading;
  }
  
  async getClub(company_id) {
    const res = await post('company', {company_id}).catch((err) => console.error('--company error', err))
    if (res) {
      this.club.fromJson(res.company);
      let ch = []
      res.company.children.map((child) => {
        const c = new Club();
        c.fromJson(child);
        ch.push(c)
      })
      if (ch) {
        this.club.setProperty('children', ch)
      }
      if (!this.member.id) {
        this.member.company_id = this.club.id;
      }
    }
  }
  
  async saveMember() {
    const isValid = this.member.validate();
    if (isValid) {
      const res = await post('save_company_user', this.member)
        .catch((err) => console.error('--member save error', err))
      if (res) {
        this.member.fromJson(res.company_user);
        return Promise.resolve(this.member)
      }
    }
    return Promise.reject(new Error('please_check_data'))
  }

  setMembers(members) {
    this.members = members;
  }
  
  resetMember() {
    this.member = new Member();
  }
  
  fetchMembers = async (append) => {
    this.setLoading(true)
    try {
      const response = await post('get_company_users', this.memberQuery).catch((err) => console.error('--members list error', err))
      if (response && response.result === 0) {
        let mm = []
        response.items.map((member) => {
          const m = new Member();
          m.fromJson(member);
          mm.push(m)
        })
        if (append) {
          this.setMembers([...this.members, ...mm])
        } else {
          this.setMembers(mm)
        }
        this.memberQuery.setProperty('count', response.count)
        this.memberQuery.setProperty('page_count', response.page_count)
        this.memberQuery.setProperty('page_number', response.page_number)
      }
      return Promise.resolve(response)
    } catch (err) {
      console.error('--members list error', err)
      return Promise.reject(err)
    } finally {
      this.setLoading(false)
    }
  }

  async getMembers() {
    if (this.loading) return;
    console.log('--get members initial', this.memberQuery.page_number, this.memberQuery.page_count)
    this.memberQuery.setProperty('page_number', 1)
    return this.fetchMembers(false)
  }
  
  async getMembersMore() {
    if (this.loading) return;
    if (this.memberQuery.page_number >= this.memberQuery.page_count) return;
    console.log('--get members more', this.memberQuery.page_number, this.memberQuery.page_count)
    this.memberQuery.setProperty('page_number', this.memberQuery.page_number + 1)
    return this.fetchMembers(true)
  }
  
  async getMember(member_id) {
    const res = await post('get_company_users', {...this.memberQuery, ...{company_user_id: member_id}}).catch((err) => console.error('--member get error', err))
    if (res) {
      let m = res.items[0]
      this.member.fromJson(m);
      if (m.role_id === 'MMBR') {
        let mother = new Person('mother');
        mother.fromJson(m.mother);
        this.member.mother = mother;
        
        let father = new Person('father');
        father.fromJson(m.father);
        this.member.father = father;
      }
      if (m.role_id === 'PRNT'){
        let children = [];
        m.children.map((child) => {
          let c = new Person('child');
          c.fromJson(child);
          children.push(c)
        })
        this.member.children = children;
      }
    }
  }

  resetBranch() {
    this.branch = new Company();
  }

  async saveBranch() {
    if (!this.branch.parent_id) {
      this.branch.setProperty('parent_id', this.club.id)
    }
    const isValid = this.branch.validate();
    console.log('--branch save', isValid)
    if (isValid) {
      const res = await post('save_branch', this.branch)
        .catch((err) => console.error('--branch save error', err))
      if (res) {
        this.branch.fromJson(res.branch);
        return Promise.resolve(this.branch)
      } else {
        return Promise.reject()
      }
    }
    return Promise.reject(new Error('please_check_data'))
  }

  setBranches(branches) {
    this.branches = branches;
  }

  async getBranches() {
    const res = await post('branches', {company_id: this.club.id}).catch((err) => console.error('--branches list error', err))
    if (res) {
      this.setBranches(res.branches)
    }
  }

  async getBranch(branch_id) {
    const res = await post('branch', {branch_id}).catch((err) => console.error('--branch get error', err))
    if (res) {
      this.branch.fromJson(res.branch);
    }
  }
  
  async saveTeam() {
    if (!this.team.company_id) {
      this.team.setProperty('company_id', this.club.id)
    }
    const isValid = this.team.validate();
    if (isValid) {
      const res = await post('company/team/update', this.team)
        .catch((err) => console.error('--team save error', err))
      if (res) {
        this.team.fromJson(res.team);
        return Promise.resolve(this.team)
      } else {
        return Promise.reject()
      }
    }
    return Promise.reject(new Error('please_check_data'))
  }
  
  resetTeam() {
    this.team = new Team();
  }
  setTeams(teams) {
    this.teams = teams;
  }
  async getTeams() {
    if(!this.teamQuery.parent_id) {
      this.teamQuery.setProperty('parent_id', this.club.id)
    }
    const res = await post('company/team/list', this.teamQuery).catch((err) => console.error('--teams list error', err))
    if (res) {
      this.setTeams(res.teams)
    }
  }
  
  async getTeam(team_id) {
    const res = await post('company/team/get', {team_id}).catch((err) => console.error('--team error', err))
    if (res) {
      this.team.fromJson(res.team);
    }
  }
  
  setFreeMembers(members) {
    this.freeMembers = members;
  }
  
  async getFreeMembers() {
    if(!(this.club.id && this.team.id)) {
      return
    }
    console.log('--get free members', this.club.id, this.team.id)
    const res = await post('company/team/free_members', {company_id: this.club.id, team_id: this.team.id}).catch((err) => console.error('--free members error', err))
    if (res) {
      this.setFreeMembers(res.members)
    }
  }
  async addTeamMembers(user_ids) {
    const res = await post('company/team/member/edit', {team_id: this.team.id, company_user_ids: user_ids}).catch((err) => console.error('--add team member error', err))
    if (res) {
      this.team.fromJson(res.team);
      return this.getFreeMembers()
    } else {
      return Promise.reject()
    }
  }
  async deleteTeamMember(team_member_id) {
    const res = await post('company/team/member/delete', {
      team_member_id
    }).catch((err) => console.error('--delete team member error', err))
    if (res) {
      this.team.members = this.team.members.filter(m => m.id !== team_member_id)
      this.team.fromJson(res.team);
      return this.getFreeMembers()
    } else {
      return Promise.reject()
    }
  }
}

const clubStore = new ClubStore();
export default clubStore;